"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTableHead = void 0;
const table_cell_1 = require("client/components/material/table/table-cell");
const table_row_1 = require("client/components/material/table/table-row");
const ArrowDropDown_1 = require("material-ui-icons/ArrowDropDown");
const ArrowDropUp_1 = require("material-ui-icons/ArrowDropUp");
const Table_1 = require("material-ui/Table");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./table-head.less");
let MaterialTableHead = class MaterialTableHead extends react_1.Component {
    constructor() {
        super(...arguments);
        this.createSortHandler = (property) => {
            this.props.onRequestSort(property);
        };
    }
    render() {
        const { checkbox, columns, order, orderBy } = this.props;
        return (React.createElement(Table_1.TableHead, null,
            React.createElement(table_row_1.MaterialTableRow, { header: true },
                checkbox && (React.createElement(Table_1.TableCell, { className: "table-head-checkbox" }, checkbox)),
                columns.map(column => (React.createElement(table_cell_1.MaterialTableCell, { avatar: column.avatar, center: column.center, key: column.label, header: true, numeric: column.numeric },
                    React.createElement(Table_1.TableSortLabel, { disabled: column.sortable === false, onClick: () => this.createSortHandler(column.id) },
                        column.label,
                        React.createElement("div", { className: "material-table-head__arrow-container" },
                            orderBy === column.id && order === "ASC" && (React.createElement(ArrowDropUp_1.default, null)),
                            orderBy === column.id && order === "DESC" && (React.createElement(ArrowDropDown_1.default, null))))))))));
    }
};
MaterialTableHead = __decorate([
    mobx_react_1.observer
], MaterialTableHead);
exports.MaterialTableHead = MaterialTableHead;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/table/table-head/table-head.tsx
// module id = 3269
// module chunks = 0